import { Price } from '@app/entities/price';

export type PaymentDetailInfoVM = Readonly<{
  Price: Price,
  ProductReference: string;
}>;

export enum PaymentDiscountType {
  DiscountAmount = 'DiscountAmount',
  Strikethrough = 'Strikethrough'
}

